// extracted by mini-css-extract-plugin
export default {"TagPopover":"webpack-pages-StudyList-StudyListToolbar-components-TagPopover-module__TagPopover"};